import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export interface CreateReactionMutation {
  createReaction: {
    id: string;
    value: string;
  };
}

export interface CreateReactionMutationVariables {
  input: {
    id: string;
    value: string;
  };
}

export const CREATE_REACTION: TypedDocumentNode<
  CreateReactionMutation,
  CreateReactionMutationVariables
> = gql`
  mutation CreateReaction($input: CreateReactionInput!) {
    createReaction(input: $input) {
      id
      value
    }
  }
`;
